import { render } from "./clipboard_Form.vue?vue&type=template&id=db79e9b2"
import script from "./clipboard_Form.vue?vue&type=script&lang=js"
export * from "./clipboard_Form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__